export default {
  path: '',
  name: 'Landing',
  component: () =>
    import(
      /* webpackChunkName: "landing-index" */
      /* webpackPreload: true */
      '@/views/landing/Index.vue'
    ),
  meta: { requiredGoals: true, requiredVcp: true },
  children: [
    {
      name: 'LandingNewOrder',
      path: '/standard/instant-order/:orderId?',
      meta: { requiredGoals: false, requiresAuth: true },
      component: () =>
        import(
          /* webpackChunkName: "dashboard-checkout" */
          '@/components/core/lib/Checkout/CheckoutWrapper.vue'
        ),
    },
    {
      name: 'LandingOrderDelivery',
      path: '/standard/order-delivery/:orderId?',
      meta: { requiredGoals: false, requiresAuth: true },
      component: () =>
        import(
          /* webpackChunkName: "dashboard-checkout" */
          '@/components/core/lib/Checkout/CheckoutDelivery.vue'
        ),
    },
  ],
}
